import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import store from "store";
import { Provider } from "react-redux";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AnimatedRoutes from "Routes";

function App() {
  
  return (
    <div className="select-none">
      <HelmetProvider>
        <Helmet>
          <title>Yonde</title>
          <meta name="description" content="Aprende japonés leyendo cuentros tradicionales." />
        </Helmet>
        <Provider store={store}>
          <Router>
            <AnimatedRoutes />         
          </Router>
        </Provider>
      </HelmetProvider>
    </div>
    );
}

export default App;